import { IntegrationCredentials, JobLocation, RejectedReason } from './types';

// Kombo provider keys whose upstream ATS has no working reject endpoint —
// rejecting a candidate has to be modelled as a stage move into the ATS's
// "Rejected" interview stage instead. Adding a provider here flips the
// REJECTED status flow from rejection-reasons → interview-stages across
// every status-change surface (rejection modal, status drawer, analysis
// drawer). Match Kombo's provider strings exactly (`KomboProvider` enum
// on the integration service).
export const KOMBO_PROVIDERS_USING_INTERVIEW_STAGES_FOR_REJECTION: readonly string[] =
  ['logicmelon', 'pinpoint', 'jobadder'];

export const isInterviewStageBasedRejection = (
  integration: IntegrationCredentials | null | undefined
): boolean => {
  if (!integration?.komboIntegrationId || !integration?.provider) {
    return false;
  }
  return KOMBO_PROVIDERS_USING_INTERVIEW_STAGES_FOR_REJECTION.includes(
    integration.provider
  );
};

const parseAtsJobDescription = ({
  content,
  jobTitle,
  locations
}: {
  content: string;
  jobTitle: string;
  locations: JobLocation[];
}) => {
  return `Job Title: ${jobTitle ?? ''}
Locations: ${locations.map((location) => location.name).join(', ')}
Role description:
${content ?? ''}`;
};

const isRejectionEnabled = (
  integration: IntegrationCredentials | null,
  atsJobId: string | undefined | null,
  isGreenhouseFeatureFlagEnabled?: boolean
) => {
  if (!atsJobId) {
    return false;
  }

  // Enable the rejected reasons only Lever ATs
  if (integration?.provider === 'lever') {
    return true;
  }

  return !!isGreenhouseFeatureFlagEnabled;
};

const formatRejectedReasons = (
  rejectedReasons: RejectedReason[],
  provider: string | undefined | null
) => {
  if (provider === 'greenhouse') {
    return rejectedReasons.map((reason) => ({
      id: reason.id,
      label: `${reason.label} - ${reason.type} `,
      type: reason.label
    }));
  }

  return rejectedReasons;
};

const isListsAvailable = ({
  provider,
  isConnected
}: {
  isConnected: boolean;
  provider: string;
}) => {
  return isConnected && ['bullhorn_ats', 'bullhorn'].includes(provider);
};

export {
  parseAtsJobDescription,
  isRejectionEnabled,
  formatRejectedReasons,
  isListsAvailable
};
